<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  // Seconds left before the edit can no longer be saved. Null for a private
  // note, where a day is not a deadline anyone needs to watch.
  secondsLeft: {
    type: Number,
    default: null,
  },
  isPrivateNote: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['cancel']);

const countdown = computed(() => {
  if (props.secondsLeft === null) return '';
  const minutes = Math.floor(props.secondsLeft / 60);
  const seconds = String(props.secondsLeft % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
});

// Turns urgent in the last fifteen seconds, so a countdown that is about to run
// out is noticed without having to watch it.
const isRunningOut = computed(
  () => props.secondsLeft !== null && props.secondsLeft <= 15
);
</script>

<template>
  <div
    class="reply-editor bg-n-slate-9/10 rounded-md py-1 pl-2 pr-1 text-xs tracking-wide mt-2 flex items-center gap-1.5 -mx-2"
  >
    <span class="flex-shrink-0 i-lucide-pencil size-3.5" aria-hidden="true" />
    <div class="flex-grow gap-1 mt-px text-xs truncate">
      {{
        isPrivateNote
          ? $t('CONVERSATION.EDIT_MESSAGE.EDITING_NOTE')
          : $t('CONVERSATION.EDIT_MESSAGE.EDITING')
      }}
    </div>
    <span
      v-if="countdown"
      class="flex-shrink-0 tabular-nums"
      :class="isRunningOut ? 'text-n-ruby-11 font-medium' : 'text-n-slate-11'"
    >
      {{ $t('CONVERSATION.EDIT_MESSAGE.TIME_LEFT', { time: countdown }) }}
    </span>
    <Button
      v-tooltip="$t('CONVERSATION.EDIT_MESSAGE.CANCEL')"
      ghost
      xs
      slate
      icon="i-lucide-x"
      @click.stop="emit('cancel')"
    />
  </div>
</template>
